import * as React from 'react';
import { connect } from 'react-redux';
import { formValueSelector } from 'redux-form';
import { withProps, compose } from 'recompose';
import { Grid, Row, Col } from 'react-flexbox-grid';
import Divider from 'material-ui/Divider';

import {
  Input,
  InputField,
  NumberSequence,
  RemoteAutoCompleteField,
  RemoteAutoComplete,
  InlineGrid,
  InlineGridField
} from '@components/form';
import { ProtocolsRowForm } from '@modules/protocols/ProtocolsRowForm';
import { protocolsRowColumns } from '@modules/protocols/_protocolsColumns';
import { required } from '@utils/validators';

const enhance = compose<any, any>(
  connect((state: any) => ({
    warehouse: formValueSelector('ProtocolsGrid')(state, 'warehouse'),
    employee: formValueSelector('ProtocolsGrid')(state, 'employee')
  })),
  withProps(({ protocolType, warehouse, employee }) => {
    let itemsUrl = '';
    let itemsParams = {};

    switch (protocolType.id) {
      case 'disposal':
      case 'issue':
      case 'transfer':
        itemsUrl = warehouse ? `/metropolis/api/wa/warehouses/${warehouse.id}/items` : '';
        break;
      case 'procurement':
        itemsUrl = '/metropolis/api/wa/cards';
        break;
      case 'receipt':
        itemsUrl = employee ? `/metropolis/api/hr/employees/${employee.id}/items` : '';
        break;
      default:
        break;
    }

    return { itemsUrl, itemsParams };
  })
);

const View: React.SFC<any> = ({ protocolType, disabled, itemsUrl, itemsParams }) => (
  <div>
    <Grid fluid={true}>
      <Row>
        <Col className="grid-system-margin" />
      </Row>
      <Row>
        <Col md={12} xl={4}>
          <NumberSequence
            inputName={'number'}
            formName={'ProtocolsGrid'}
            style={{ height: '100%' }}
            sequenceKey={protocolType.sequenceKey}
            disabled={disabled}
            inputProps={{ disabled: true }}
          />
        </Col>
        <Col md={12} xl={4}>
          <RemoteAutoCompleteField
            component={RemoteAutoComplete}
            fullWidth={true}
            disabled={disabled}
            validate={[required]}
            {...protocolType.firstAutocompleteField}
          />
        </Col>
        <Col md={12} xl={4}>
          <RemoteAutoCompleteField
            component={RemoteAutoComplete}
            fullWidth={true}
            disabled={disabled}
            validate={[required]}
            {...protocolType.secondAutocompleteField}
          />
        </Col>
        <Col md={12}>
          <InputField
            component={Input}
            multiLine={true}
            id="note"
            name="note"
            label={'Poznámka'}
            style={{ maxHeight: '60vh' }}
            inputStyle={{ maxHeight: '60vh' }}
            textareaStyle={{ maxHeight: '56vh' }}
          />
        </Col>
      </Row>
      <Row>
        <Col md={12}>
          <InlineGridField
            component={InlineGrid}
            name="rows"
            Form={withProps({ type: protocolType.id, itemsUrl, itemsParams })(ProtocolsRowForm)}
            columns={protocolsRowColumns}
            showCheckboxes={true}
            adding={!disabled && !!itemsUrl}
            editing={!disabled}
            deleting={!disabled}
          />
        </Col>
      </Row>
    </Grid>

    <Divider />
  </div>
);

export const ProtocolsFormBasic = enhance(View);



// WEBPACK FOOTER //
// ./src/modules/protocols/ProtocolsFormBasic.tsx